import { render, staticRenderFns } from "./ChartBar2.vue?vue&type=template&id=f1718888&scoped=true&"
import script from "./ChartBar2.vue?vue&type=script&lang=js&"
export * from "./ChartBar2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1718888",
  null
  
)

export default component.exports